export const SET_JOB_FILTER = 'SET_JOB_FILTER';
export const SET_JOB_FILTER_COUNT = 'SET_JOB_FILTER_COUNT';
export const RESET_JOB_FILTER = 'RESET_JOB_FILTER';
export const SET_JOB_SEAERCH = 'SET_JOB_SEAERCH';
export const SET_IS_JOB_FILTER_USED_FIRST_TIME =
  'SET_IS_JOB_FILTER_USED_FIRST_TIME';
